export var isUrl = function (str) { return str.startsWith("http"); };
export var isDataUrl = function (str) { return str.startsWith("data:"); };
export var isInternalFileUrl = function (str) {
    return str.includes("/api/files") || str.includes("/api/v3/documents");
};
